<script>
export default {
  name: 'UserLayout',
  data() {
    return {
      // Retrieve the user's email from local storage
      userEmail: JSON.parse(localStorage.getItem('user'))["email"]
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      this.$router.push('/login');
    }
  }
};
</script>

<template>
  <div class="flex h-screen flex-col overflow-hidden">
    <!-- Top Navigation Bar -->
    <header class="shrink-0 bg-blue-200 text-blue-900 p-4 flex items-center justify-between shadow-md">
      <div class="flex items-center space-x-6">
        <!-- Library title -->
        <span class="text-base font-bold whitespace-nowrap">
          SBU Geosciences Spectral Library
        </span>

        <!-- Visual separator -->
        <span class="h-5 border-l border-blue-400"></span>

        <!-- User email display -->
        <span class="text-sm font-semibold whitespace-nowrap">
          {{ userEmail }}
        </span>

        <!-- Navigation links -->
        <nav>
          <ul class="flex space-x-6">
            <li>
              <router-link
                to="/user/main-layout"
                class="hover:text-blue-700"
                exact-active-class="font-bold text-blue-950"
              >
                Library Home
              </router-link>
            </li>

            <li>
              <router-link
                to="/user/folder-management"
                class="hover:text-blue-700"
                exact-active-class="font-bold text-blue-950"
              >
                Folder Management
              </router-link>
            </li>

            <li>
              <router-link
                to="/user/upload-file"
                class="hover:text-blue-700"
                exact-active-class="font-bold text-blue-950"
              >
                Upload File
              </router-link>
            </li>

            <li>
              <router-link
                to="/user/change-password"
                class="hover:text-blue-700"
                exact-active-class="font-bold text-blue-950"
              >
                Change Password
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
      <!-- Logout button -->
      <button @click="logout" class="text-sm underline hover:text-blue-700 focus:outline-none">
        Logout
      </button>
    </header>
    <!-- Main Content Area -->
    <main class="min-h-0 flex-1 overflow-auto bg-white p-8">
      <router-view></router-view>
    </main>
  </div>
</template>

<style scoped>
/* Additional modern styling can be added as needed */
</style>
